import { IconChevronChevronRight } from '@doltech/icons/IconChevronChevronRight';
import { QuestionCircle, QuestionDisplayMode } from '@doltech/ui/lib/figma/CircleText/CircleText';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { Box } from '@doltech/ui/lib/figma/Common/BoxV2';
import { Typography } from '@doltech/ui/lib/figma/DesignSystemV2/Typography';
import { TextWithLinkPdf } from '@doltech/ui/lib/figma/Layout/Landing/Content/TextWithLinkPdf';
import { Link } from '@doltech/ui/lib/figma/Link';
import { usePdfTrackingParams } from '@doltech/utils/lib/pdf';
import { getLandingUrlFromPath, mergeUrlWithParams } from '@doltech/utils/lib/url';
import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { ParaphrasingViewOnlyComponent } from '../../paraphrasing/ParaphrasingViewOnly';

const ViewExplanationAction = styled(Link).withConfig({
  componentId: 'AnswerKeyRow_ViewExplanationAction',
} as any)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  border-radius: 8px;
  color: ${colorsV2.primary100};
  background-color: ${colorsV2.primary10};
  cursor: pointer;
  margin-top: 16px;
`;

const Container = styled.div.withConfig({
  componentId: 'AnswerKeyRow_Container',
} as any)`
  cursor: pointer;

  .row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) max-content;
    align-items: center;
  }

  .column {
    &.left {
      display: grid;
      grid-template-columns: 24px minmax(0, 1fr);
      align-items: center;
      column-gap: 8px;
    }
  }
`;

export interface AnswerKeyModel {
  no: number;
  answer: string;
  explanation: any;
  explanationLink: any;
}

interface AnswerKeyItemProps {
  data: AnswerKeyModel;
  isPdfContent?: boolean;
  isShowExplanation: boolean;
}

export const AnswerKeyItem = (props: AnswerKeyItemProps) => {
  const { data, isPdfContent = false, isShowExplanation = false } = props;
  const { no, answer, explanation, explanationLink } = data;
  const pdfTrackingParams = usePdfTrackingParams();

  return (
    <Container className="track-item">
      <div className="row">
        <div className="column left">
          <QuestionCircle
            className={cl('question-circle', QuestionDisplayMode.QUESTION_OPTION_CORRECT)}
          >
            <span>{no}</span>
          </QuestionCircle>
          <Typography.Text variant="medium/14">{answer}</Typography.Text>
        </div>
        <div className="column right">
          {isPdfContent ? (
            <TextWithLinkPdf
              text="Xem full giải thích"
              link={mergeUrlWithParams(explanationLink.pathname, {
                ...explanationLink.query,
                ...pdfTrackingParams,
              })}
              variant="medium/14"
            />
          ) : (
            !isShowExplanation && (
              <Link
                prefetch={false}
                href={{
                  pathname: getLandingUrlFromPath(explanationLink.pathname),
                  query: explanationLink.query || {},
                }}
                target="_blank"
              >
                <Typography.Text variant="medium/14">Xem full giải thích</Typography.Text>
                <IconChevronChevronRight fontSize={18} ml="4px" />
              </Link>
            )
          )}
        </div>
      </div>
      {!isPdfContent && isShowExplanation && (
        <Box pt="16px">
          <Typography.Title level={4} variant="semi-bold/16" mb="16px">
            Giải thích chi tiết
          </Typography.Title>
          <ParaphrasingViewOnlyComponent
            className="explanation-detail-section"
            initValue={explanation?.detailExplanation}
            limit={5}
            withCardLayout={false}
          />
          <ViewExplanationAction
            prefetch={false}
            href={{
              pathname: getLandingUrlFromPath(explanationLink.pathname),
              query: explanationLink.query || {},
            }}
            target="_blank"
          >
            <Typography.Text variant="medium/14">Xem full giải thích</Typography.Text>
            <IconChevronChevronRight fontSize={18} ml="4px" />
          </ViewExplanationAction>
        </Box>
      )}
    </Container>
  );
};
